module.exports = __webpack_public_path__ + "static/media/PlayARt.56df5ba7.gif";